export default __webpack_public_path__ + "static/vtu-89767a9b4b863beb5c376e15c9d5d3c0.mp4";